// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    CaseAllowedCaseStatusModels,
    CaseGenericCaseModelResponse,
    CaseProgramCaseTypeModels,
    CaseSearchModel,
    CaseSearchResultModelCaseCaseModelResponse,
    CaseTypeModels,
    CaseTypeStatusModels,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class CaseV3Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Get list of allowed Case Statuses by Program and Case Type identifiers
     * @param caseTypeId Case Type identifier
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async allowedCaseStatusGetByProgramId (caseTypeId: number, xProgramId?: number): Promise<AxiosResponse<CaseAllowedCaseStatusModels>> {
        const _url_ = '/case/v3/AllowedCaseStatus/{caseTypeId}'
            .replace('{' + 'caseTypeId' + '}', encodeURIComponent(String(caseTypeId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'caseTypeId' is not null or undefined
        if (caseTypeId === null || caseTypeId === undefined) {
            throw new Error('Required parameter caseTypeId was null or undefined when calling allowedCaseStatusGetByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CaseAllowedCaseStatusModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseAllowedCaseStatusModels");
        }
        return response;
    }
    /**
     * 
     * @summary Search for available Cases that match Program identifier and specified criteria.
     * @param caseSearchModel CaseSearchModel object containing search criteria
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async caseSearchByProgramId (caseSearchModel: CaseSearchModel, xProgramId?: number): Promise<AxiosResponse<CaseSearchResultModelCaseCaseModelResponse>> {
        const _url_ = '/case/v3/CaseSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'caseSearchModel' is not null or undefined
        if (caseSearchModel === null || caseSearchModel === undefined) {
            throw new Error('Required parameter caseSearchModel was null or undefined when calling caseSearchByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(caseSearchModel, "CaseSearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CaseSearchResultModelCaseCaseModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseSearchResultModelCaseCaseModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get list of all available Case Types.
     * @param surveyId 
     */
    public async caseTypeGet (surveyId?: number): Promise<AxiosResponse<CaseTypeModels>> {
        const _url_ = '/case/v3/CaseType';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (surveyId !== undefined) {
            _params_['surveyId'] = Serializer.serialize(surveyId, "number");
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CaseTypeModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseTypeModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get list of available Case Type Statuses by Program and Case Type identifiers.
     * @param caseTypeId Case Type identifier
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async caseTypeStatusGetByProgramId (caseTypeId: number, xProgramId?: number): Promise<AxiosResponse<CaseTypeStatusModels>> {
        const _url_ = '/case/v3/CaseTypeStatus/{caseTypeId}'
            .replace('{' + 'caseTypeId' + '}', encodeURIComponent(String(caseTypeId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'caseTypeId' is not null or undefined
        if (caseTypeId === null || caseTypeId === undefined) {
            throw new Error('Required parameter caseTypeId was null or undefined when calling caseTypeStatusGetByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CaseTypeStatusModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseTypeStatusModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get a generic Case
     * @param caseId 
     */
    public async genericCaseGet (caseId: number): Promise<AxiosResponse<CaseGenericCaseModelResponse>> {
        const _url_ = '/case/v3/GenericCase/{caseId}'
            .replace('{' + 'caseId' + '}', encodeURIComponent(String(caseId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'caseId' is not null or undefined
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling genericCaseGet.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CaseGenericCaseModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseGenericCaseModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get list of available Program Case Types by Program identifier.
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async programCaseTypeGetByProgramId (xProgramId?: number): Promise<AxiosResponse<CaseProgramCaseTypeModels>> {
        const _url_ = '/case/v3/ProgramCaseType';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CaseProgramCaseTypeModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CaseProgramCaseTypeModels");
        }
        return response;
    }
}
